export default "skymp5-front/e6bbbc53c6e0f72c86157595981a303d.png";